import { Injectable } from '@angular/core';
import { IsAuthenticated } from './isAuthenticated';
import { combineLatest, Observable } from 'rxjs';
import { concatMap, filter, take } from 'rxjs/operators';
import { AuthState } from '../state/auth.state';
import { Actions, Store } from '@ngxs/store';
import { LoggerService } from '../../../modules/shared/services/logger.service';
import { JwtHelperService } from '@jjmhalew/angular-jwt';

@Injectable({
    providedIn: 'root'
})
export class PasswordAuthenticatedService implements IsAuthenticated {

    constructor(
        private logger: LoggerService,
        private jwtService: JwtHelperService,
        private store: Store,
        private actions$: Actions
    ) {}

    csIsAuthenticated$(): Observable<boolean> {
        const token$ = this.store.selectOnce(AuthState.token);
        const refreshToken$ = this.store.selectOnce(AuthState.refreshToken);
        const authenticationInProgress$ = this.store.selectOnce(AuthState.authenticationInProgress);
        const isStartingUp$ = this.store.selectOnce(AuthState.isStartingUp);

        return combineLatest([ token$, refreshToken$, authenticationInProgress$, isStartingUp$ ]).pipe(
            filter(([ , , inProgress, isStartingUp ]) => !inProgress || isStartingUp),
            concatMap(() => this.store.selectOnce(AuthState.validated)),
            take(1)
        );
    }
}
